import React, { useEffect, useRef } from 'react';
import { API_BASE } from '../services/api';

export default function Background() {
  const videoRef = useRef(null);

  useEffect(() => {
    // Force video play on mount
    const playVideo = async () => {
        if (videoRef.current) {
            try {
                videoRef.current.currentTime = 0;
                await videoRef.current.play();
            } catch (e) {
                console.log("Video autoplay failed:", e);
            }
        }
    };
    playVideo();
  }, []);

  return (
    <div style={{
      position: 'absolute',
      inset: 0,
      zIndex: 0,
      overflow: 'hidden',
      background: '#000',
    }}>
      <video
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block'
        }}
      >
        <source src={`${API_BASE}/videos/background1.mp4`} type="video/mp4" />
        <source src="/videos/background1.mp4" type="video/mp4" />
      </video>
    </div>
  );
}
